export const homeMaintenanceLogo = '/assets/images/home-maintenance-logo.png';
